import React, { Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { visibleIf } from 'Core/Utils';
import ErrorView from 'Core/Status/ErrorView';
import LoadingView from 'Core/Status/LoadingView';

import Header from 'Site/Ui/Header';
import Footer from 'Site/Ui/Footer';
import PublicStore from 'Site/State/Store';
import { loadSite } from 'Site/State/Actions';

import 'Site/Style';
import PublicRoutes from 'Site/Routes';

class Site extends React.Component {
  constructor (props) {
    super(props);
    this.state = PublicStore.getState();
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    loadSite();
  }

  componentDidMount () {
    this.unsubscribe = PublicStore.subscribe(() => {
      const state = PublicStore.getState();
      this.setState(state);
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  render () {
    const { location } = this.props;
    const { pages, blogs, ui } = this.state;
    const { errorMessage, siteBroken, siteLoading } = ui;

    return (
      <div className="Public Root">
        <ErrorView style={visibleIf(siteBroken)} message={errorMessage} />
        <LoadingView style={visibleIf(siteLoading)} />
        <div style={visibleIf(!siteLoading && !siteBroken)}>
          <Route component={Header} />
          <Switch>
            <Redirect exact from="/" to="/home" />
            <PublicRoutes pages={pages} blogs={blogs} />
          </Switch>
          <Route component={Footer} />
        </div>
      </div>
    );
  }
};

export default Site;



// WEBPACK FOOTER //
// ./client/Site/Site.jsx